import { startBot } from "../store/chatSlice";
import { useAppDispatch } from "../store/hooks";
import "./Welcome.css";

const Welcome = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="chatbot-wrapper">
      <div className="logo">
        <img src="/logo.png" style={{ width: "200px" }} alt="EDP logo" />
      </div>
      <div className="chatbot-widget">
        <div className="chatbot-bubble">
          <div className="animated-avatar">
            <div className="main">
              <div className="scale-0">
                <img src="/ss2.png" style={{ position: "relative", zIndex: 10, height: "99px", left: "2px" }} alt="" className="rotating" />
                <div className="circle circle-1" />
                <div className="circle circle-2" />
                <div className="circle circle-3" />
              </div>
            </div>
          </div>
        </div>

        <div className="chatbot-content">
          <h1>Welcome to École des Ponts Business School.</h1>
          <p>I&apos;m Cely.ai, your admissions companion at École des Ponts Business School.</p>
          <button className="talk-btn" onClick={() => dispatch(startBot())}>
            Let&apos;s Talk
          </button>
        </div>
      </div>
      <div className="powered-by fcc">
        Powered by
        <img src="https://askdisha.irctc.co.in/static/media/corover.7f27379178b8dd4508c5.png" alt="" />
      </div>
    </div>
  );
};

export default Welcome;
